import type { Dispatch } from 'react';

import { FIELD_TYPES } from '../constants';
import type { BuilderAction } from '../builderReducer';
import type { FieldType } from '../types';

interface QuestionTypeSelectProps {
    dispatch: Dispatch<BuilderAction>;
    fieldType: string;
    questionId: string;
}

export function QuestionTypeSelect({ dispatch, fieldType, questionId }: QuestionTypeSelectProps) {
    return (
        <select
            value={fieldType}
            onChange={(event) =>
                dispatch({
                    type: 'updateQuestionType',
                    questionId,
                    fieldType: event.target.value as FieldType,
                })
            }
            className="flex h-10 w-full rounded-xl border border-input bg-background px-3 py-2 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
            {FIELD_TYPES.map((fieldTypeOption) => (
                <option key={fieldTypeOption.value} value={fieldTypeOption.value}>
                    {fieldTypeOption.label}
                </option>
            ))}
        </select>
    );
}
